import React, { ComponentPropsWithoutRef } from "react";
import Image from "react-bootstrap/Image";
import { useNavigate } from "react-router-dom";

import BackButton from "../../../images/left-arrow-white.svg";
import "./OnboardingHeader.scss";

interface IOnboardingHeaderProps extends ComponentPropsWithoutRef<"div"> {
  amountActive?: number;
  onClick?: () => void;
  steps?: number;
  showProgress?: boolean;
  showBackButton?: boolean;
}

function OnboardingHeader({
  amountActive,
  onClick,
  steps = 2,
  showProgress = true,
  showBackButton = true,
  className = "",
  ...props
}: IOnboardingHeaderProps) {
  const navigate = useNavigate();

  const back = () => {
    if (onClick) {
      onClick();
      return;
    }
    navigate(-1);
  };

  const progressPercent =
    amountActive && steps ? Math.min((amountActive / steps) * 100, 100) : 0;

  return (
    <div className={`OnboardingHeader ${className}`} {...props}>
      {showBackButton ? (
        <button className="OnboardingHeaderBackButton" onClick={back}>
          <Image src={BackButton} alt="go back" />
        </button>
      ) : null}
      {showProgress && amountActive ? (
        <>
          <div
            className="OnboardingProgressTrack"
            aria-label="Progress"
            role="progressbar"
            aria-valuemin={1}
            aria-valuemax={steps}
            aria-valuenow={amountActive}
          >
            <div
              className="OnboardingProgressFill"
              style={{ width: `${progressPercent}%` }}
            />
          </div>
          <p className="OnboardingStepCounter">
            {amountActive}/{steps}
          </p>
        </>
      ) : null}
    </div>
  );
}

export default OnboardingHeader;
